// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dock_wrapper__2rkAK","active":"dock_active__DYRXN"};